(function (global) {
  'use strict';

  const text = (value) => String(value ?? '').trim();
  const countryOf = (state = {}) => text(state.settings?.countryCode || state.settings?.country || state.settings?.businessCountry).toUpperCase();
  const productsOf = (state = {}) => Array.isArray(state.products) ? state.products : [];
  const isActiveTrackedProduct = (product = {}) => (
    text(product.kind || product.type).toLowerCase() === 'physical'
    && product.inventoryTracking === true
    && text(product.inventoryCostMethod) === 'weighted_average'
    && !['archived', 'passiv', 'inactive'].includes(text(product.status).toLowerCase())
  );
  const trackedProducts = (state = {}) => productsOf(state).filter(isActiveTrackedProduct);

  const resolve = (state = {}) => {
    const settings = state.settings || {};
    const supported = countryOf(state) === 'NO';
    const explicit = typeof settings.inventoryPurchaseTrackingEnabled === 'boolean';
    const legacyMigration = supported && !explicit && trackedProducts(state).length > 0;
    const enabled = supported && (explicit ? settings.inventoryPurchaseTrackingEnabled : legacyMigration);
    const migrated = legacyMigration || Boolean(settings.inventoryPurchaseTrackingMigratedAt);
    return {
      supported,
      enabled,
      explicit,
      legacyMigration,
      migrated,
      noticeRequired: enabled && migrated && !settings.inventoryPurchaseTrackingNoticeAcknowledgedAt,
      trackedProducts: trackedProducts(state),
    };
  };

  const settingsPatch = (enabled, state = {}, isoNow = new Date().toISOString(), acknowledge = true) => {
    const current = resolve(state);
    const patch = { inventoryPurchaseTrackingEnabled: enabled === true };
    if (current.legacyMigration || current.migrated) patch.inventoryPurchaseTrackingMigratedAt = state.settings?.inventoryPurchaseTrackingMigratedAt || isoNow;
    if (acknowledge) patch.inventoryPurchaseTrackingNoticeAcknowledgedAt = isoNow;
    return patch;
  };

  const productOption = (product = {}) => {
    const identifiers = [product.itemNumber, product.nr, product.sku, product.ean, product.gtin]
      .map(text).filter(Boolean);
    const stock = Number(product.stockQuantity ?? product.stock ?? 0) || 0;
    return {
      value: text(product.id),
      label: text(product.name) || text(product.description) || text(product.id),
      description: [...new Set(identifiers), `${stock} ${global.t ? global.t('buy.inventoryUnitsInStock') : 'på lager'}`].join(' · '),
    };
  };

  global.PlummeInventoryPurchaseSettings = Object.freeze({ resolve, settingsPatch, productOption, isActiveTrackedProduct });
})(window);
